import { render } from "./AlertStatus.vue?vue&type=template&id=5f74c702"
import script from "./AlertStatus.vue?vue&type=script&lang=js"
export * from "./AlertStatus.vue?vue&type=script&lang=js"
script.render = render

export default script